import { get, patch } from '../utils/api';
import { postChildJournal } from '../child-journals/api';

export { postChildJournal };

export const getUnassignedBookEntitlements = () => get('/v3/journal_entitlements?unassigned=true&kind=book');
export const getUnassignedAddOnEntitlements = () => get('/v3/journal_entitlements?unassigned=true&kind=add_on');
export const getMyChildJournals = () => get('/v3/child_journals?section=assigned');
// Journals that exist but haven't been assigned yet — shown in the Unassigned tab
// alongside the unassigned book entitlements.
export const getUnassignedChildJournals = () => get('/v3/child_journals?section=unassigned');
export const getGiftCertificates = () => get('/v3/commerce/gift_certificates');
export const getShopifyOrders = () => get('/v3/shopify_orders');

// The server documentation gives these two mutation bodies as flat JSON (not the
// JSON:API `{ data: { attributes } }` envelope used elsewhere in this app), so the
// literal shape below is intentional, not an oversight.
export const patchJournalEntitlement = (id, childJournalId) =>
  patch(`/v3/journal_entitlements/${id}`, { child_journal_id: childJournalId });

export const bulkPatchJournalEntitlements = assignments =>
  patch('/v3/journal_entitlements/bulk', { assignments });

export const resendGiftCertificateEmail = (id) =>
  patch(`/v3/commerce/gift_certificates/${id}/resend`);
// PATCH /v3/commerce/gift_certificates/:coupon_code/redeem
// The operation that actually transfers ownership of the gift (and its
// pre-created journal) to the authenticated recipient, returning the certificate
// in the `redeemed` state. Distinct from `/claim`, which runs during signup.
export const redeemGiftCertificate = couponCode =>
  patch(`/v3/commerce/gift_certificates/${couponCode}/redeem`);
